module.exports = __webpack_public_path__ + "static/media/currency.3c725da5.svg";